import Navbar from "../Components/Navbar";
import Profile from '../Components/Profile';
import CleanerDetail from '../Components/CleanerProfile/CleanerDetail';
import Testimonials from '../Components/Testimonials';
import Endorsements from '../Components/Endorsements';
import Listing from '../Components/JobListing/Listing';
import SimilarUser from '../Components/CleanerProfile/SimilarUser';
import Footer from "../Components/Footer";
import { firestore } from '../firebase.js';
import React, { useContext } from "react";
import { UserContext } from "../Providers/UserProvider";


function CleanerProfile(props) {
  const [userProfile, setUserProfile] = React.useState({});

  React.useEffect(() => {
    getUserData(props.match.params.id);
  }, []);

  const user = useContext(UserContext);

  const getUserData = (userId) => {
    firestore.collection('users').doc(userId).get()
      .then(res => {
        let userProfile = res.data();
        setUserProfile(userProfile);
      })
      .catch(err => {
        console.log(err);
      })
  };

  const calculateHired = () => {
    if (userProfile.job === 'employer') {
      let counter = 0;
      userProfile.jobs.forEach(job => {
        if (job.status === 'chosen') {
          counter++;
        }
      });
      return counter;
    };
  }

  //upvote endorsement
  const upvoteEndorse = (endorsement) => {
    firestore.collection('users').doc(user.uid).get()
      .then(res => {
        let userVote = 0;
        let userData = res.data().endorsed;
        let indexOfEndorsement = userData.findIndex(item => {
          return item.userId === props.match.params.id
        });
        if (userData[indexOfEndorsement][endorsement] === -1) {
          userData[indexOfEndorsement][endorsement] = 1;
          userVote = 2;
        } else if (userData[indexOfEndorsement][endorsement] === 0) {
          userData[indexOfEndorsement][endorsement] = 1;
          userVote++;
        } else {
          userData[indexOfEndorsement][endorsement] = 0;
          userVote--;
        }
        firestore.collection('users').doc(user.uid).update({
          endorsed: userData
        })
          .then(res => {
            firestore.collection('users').doc(props.match.params.id).get()
              .then(res => {
                let profileData = res.data().endorsements;
                let indexOfE = profileData.findIndex(item => {
                  return item.name === endorsement;
                });
                if (userVote == 2) {
                  profileData[indexOfE].down++;
                  profileData[indexOfE].up++;
                } else if (userVote == 1) {
                  profileData[indexOfE].up++;
                } else if (userVote == -1) {
                  profileData[indexOfE].up--;
                }
                firestore.collection('users').doc(props.match.params.id).update({
                  endorsements: profileData
                })
                  .then(res => {
                    getUserData(props.match.params.id);
                  })
                  .catch(err => {
                    console.log(err);
                  })
              })
          })
      })
  }

  //downvote endorsement
  const downvoteEndorse = (endorsement) => {
    firestore.collection('users').doc(user.uid).get()
      .then(res => {
        let userVote = 0;
        let userData = res.data().endorsed;
        let indexOfEndorsement = userData.findIndex(item => {
          return item.userId === props.match.params.id
        });
        if (userData[indexOfEndorsement][endorsement] === -1) {
          userData[indexOfEndorsement][endorsement] = 0;
          userVote++;
        } else if (userData[indexOfEndorsement][endorsement] === 0) {
          userData[indexOfEndorsement][endorsement] = -1;
          userVote--;
        } else {
          userData[indexOfEndorsement][endorsement] = -1;
          userVote = -2;
        }
        firestore.collection('users').doc(user.uid).update({
          endorsed: userData
        })
          .then(res => {
            firestore.collection('users').doc(props.match.params.id).get()
              .then(res => {
                let profileData = res.data().endorsements;
                let indexOfE = profileData.findIndex(item => {
                  return item.name === endorsement;
                });
                if (userVote == -2) {
                  profileData[indexOfE].down--;
                  profileData[indexOfE].up--;
                } else if (userVote == 1) {
                  profileData[indexOfE].down++;
                } else if (userVote == -1) {
                  profileData[indexOfE].down--;
                }
                firestore.collection('users').doc(props.match.params.id).update({
                  endorsements: profileData
                })
                  .then(res => {
                    getUserData(props.match.params.id);
                  })
                  .catch(err => {
                    console.log(err);
                  })
              })
          })
      })
  }

  return (
    <>
      <Navbar/>
      <Profile
        name={userProfile.name}
        job={userProfile.job}
        headline={userProfile.headline}
        province={userProfile.province}
        city={userProfile.city}
        postal={userProfile.postal}
        rate={userProfile.rate}
        whimis={userProfile.whimis}
        policecheck={userProfile.policecheck}
        jobs={userProfile.jobs}
        email={userProfile.email}
        hired={calculateHired}
      />
      {
        userProfile.job === 'cleaner' ?
          <CleanerDetail
            description={userProfile.description}
            availability={userProfile.availability}
            services={userProfile.services}
          /> :
          <Listing
            user={user}
            page={'profile'}
            profile={props.match.params.id}
          />
      }
      <Testimonials
        page={"cleanerProfile"}
        title={`${userProfile.name} Reviews`}
        userProfile={userProfile}
        userReview={userProfile.reviews}
        currentUser={user}
        profileId={props.match.params.id}
      />
      <Endorsements
        endorsements={userProfile.endorsements}
        user={user}
        upvoteEndorse={upvoteEndorse}
        downvoteEndorse={downvoteEndorse}
        profileId={props.match.params.id}
      />
      <SimilarUser />
      <Footer/>
    </>
  );
}

export default CleanerProfile;